import React, { useState, useCallback } from "react";
import { useLocation, useNavigate,useParams  } from "react-router-dom";

import cross from "../assets/cross.png";
import feed from "../assets/feed.png";
import video from "../assets/video.png";

import "../Info/Steppers.css";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import Sidebar from "../profile/Sidebar";
import Navbars from "../Navbars";
function ViewListing() {

  const routeParams = useParams();
  const listingData = useSelector((state) => state.getBusiness.data);

  const [previewData, setPreviewData] = useState({});

  useEffect(() => {
    let data=listingData.filter((val)=>{
        if(val.id==routeParams.id)
        return val
    })
    setPreviewData(data[0])
    console.log("data",data)
  }, [listingData]);

  return (
    <div
        className="conatiner-fluid"
        style={{
          backgroundColor: "#F5F5F5",
          position: "relative",
          height: "100vh",
        }}
      >
        <Navbars show="none" />
        <div className="d-flex gap-2 pe-3 main_div w-100">
          <Sidebar />
          <div className="table_outer ">
    <div className="container topWrap">
        
        <div className="box_div mt-5 mb-5 box_setting">
        <div className="d-flex gap-2 align-items-center  preview_maindiv">
         
         <p className="preview_heading">Business Detail’s View</p>
       </div>
          <p className="label1 labels">1- Business Information</p>
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <p className="label1">Business Name</p>
              <input
                value={previewData?.business_name}
                className="input1"
                placeholder="Cube Adx"
              />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <p className="label1">Phone Number</p>
              <input
                value={previewData?.phone_number}
                className="input1"
                placeholder="+1490300330"
              />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <p className="label1">
                Business Email <span className="labels_span"> (Optional) </span>
              </p>
              <input
                value={previewData?.email}
                className="input1"
                placeholder="info@cubeadx.com"
              />
            </div>
          </div>
          <p className="label1 labels">2- Business Address</p>
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <p className="label1">Street# / Name</p>
              <input
                value={previewData?.street_name}
                className="input1"
                placeholder="Street# / Name"
              />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <p className="label1">City Zip</p>
              <input
                value={previewData?.city_zip}
                className="input1"
                placeholder="Zip"
              />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <p className="label1">State</p>
              <input
                value={previewData?.state}
                className="input1"
                placeholder="State"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <p className="label1 labels">3- Business Category</p>
              <input
                value={previewData?.businessCategory}
                className="input1"
                placeholder="Message Services"
              />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <p className="label1 labels">Business Website</p>
              <input
                value={previewData?.website}
                className="input1"
                placeholder="www.cubeadx.com"
              />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12"></div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12">
              {previewData.business_days_and_hours &&
                previewData.business_days_and_hours.map((elem) => {
                  return (
                    <div className="row">
                      <p className="label1 labels">Business Working Days</p>
                      <div className=" col-lg-6 col-md-6 col-sm-12 ">
                        <div className="time_div">
                          <p className="days">{elem?.day.toUpperCase()}</p>
                        </div>
                      </div>
                      <div className=" col-lg-6 col-md-6 col-sm-12 ">
                        <div className="time_div">
                          <p className="days">
                            {elem.opening_time} - {elem.closing_time}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}

            
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <p className="label1 labels">Business Description</p>
              <p>{previewData?.business_description}</p>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <p className="label1 labels">10 key words</p>
              <div className="input1 ps-2 pe-2 pb-2">
                <div className="d-flex gap-1 flex-wrap">
                  {previewData.keywords &&
                    previewData?.keywords.map((elem) => {
                      return (
                        <div className="badge_main">
                          <p>{elem.keywords}</p>
                          <div className="badge_inner">
                            <img src={cross} />
                          </div>
                        </div>
                      );
                    })}
                  {/* <div className="badge_main">
                    <p>Business</p>
                    <div className="badge_inner">
                      <img src={cross} />
                    </div>
                  </div>
                  <div className="badge_main">
                    <p>Mesa</p>
                    <div className="badge_inner">
                      <img src={cross} />
                    </div>
                  </div>
                  <div className="badge_main">
                    <p>Mesa</p>
                    <div className="badge_inner">
                      <img src={cross} />
                    </div>
                  </div>
                  <div className="badge_main">
                    <p>Mesa</p>
                    <div className="badge_inner">
                      <img src={cross} />
                    </div>
                  </div> */}
                  {/* <div className="badge_main">
                    <p>Mesa</p>
                    <div className="badge_inner">
                      <img src={cross} />
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-8 col-md-6 col-sm-12">
              <p className="label1 labels">4- Business Images</p>
              <div className="d-flex gap-1 flex-wrap">
              {previewData?.Media &&previewData.Media.map((val,ind)=>{return(
                <img style={{ height: "160px", width: "180px" }} src={val.cdn_link} />
                
              )})}
                
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <p className="label1 labels">Business Video </p>
              <img src={video} />
            </div>
          </div>
          
        
        </div>
      </div>
      </div>
      </div>
      </div>
  );
}

export default ViewListing;
